import { render, staticRenderFns } from "./testimonialPersonGraph1.vue?vue&type=template&id=5b624890&scoped=true"
import script from "./testimonialPersonGraph1.vue?vue&type=script&lang=js"
export * from "./testimonialPersonGraph1.vue?vue&type=script&lang=js"
import style0 from "./testimonialPersonGraph1.vue?vue&type=style&index=0&id=5b624890&lang=sass"
import style1 from "./testimonialPersonGraph1.vue?vue&type=style&index=1&id=5b624890&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b624890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b624890')) {
      api.createRecord('5b624890', component.options)
    } else {
      api.reload('5b624890', component.options)
    }
    module.hot.accept("./testimonialPersonGraph1.vue?vue&type=template&id=5b624890&scoped=true", function () {
      api.rerender('5b624890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testimonialPersonGraph1.vue"
export default component.exports